import { useEffect, type ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/app/providers/AuthProvider';
import { registerAllEventHandlers } from '@/modules/events';

type AppProvidersProps = {
  children: ReactNode;
};

/** Providers globales: router + autenticación. */
export function AppProviders({ children }: AppProvidersProps) {
  useEffect(() => {
    registerAllEventHandlers();
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>{children}</AuthProvider>
    </BrowserRouter>
  );
}
